
/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};



//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/engine.io-parser/lib/keys.js
// module id = ../../../../engine.io-parser/lib/keys.js
// module chunks = 3